import React from 'react';
export function TruckIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2H6.79a3 3 0 00-2.981 2.669l-.743 6.68-.408.2A2.983 2.983 0 001 14.236V18a2 2 0 002 2h1.184a2.983 2.983 0 005.632 0h4.368a2.983 2.983 0 005.632 0H21a2 2 0 002-2V5a3 3 0 00-3-3zM5.561 7H8v4H5.117l.444-4zM7 20a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm4-2h-1.184a2.982 2.982 0 00-5.632 0H9.816a2.982 2.982 0 00-5.632 0H3v-3.764a1 1 0 01.553-.894L4.236 13H8a2 2 0 002-2V7a2 2 0 00-2-2H5.784l.016-.11A1 1 0 016.79 4H20a1 1 0 011 1v13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5h-5a2 2 0 00-2 2v4a2 2 0 002 2h5a2 2 0 002-2V7a2 2 0 00-2-2zm0 6h-5V7h5v4z"
  }));
}